// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1262":"afdea06a","8842":"afdea06a"}[chunkId] + ".chunk.css";
};